import { urlApiCRM } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IParamsCRM, IParamsDocuments, IPayloadAddNewLead, IPayloadCreateCustomer, IPayloadUploadFile, IResponseAddNewLead, IResponseGetClientDetails, IResponseGetCRMListView, IResponseGetDocuments, IParamsActivities, IResponseGetActivities } from '~/utils/interface/crm';

export interface IJobEntity {
  id: string;
  jobName: string;
  jobNumber: string;
  createdAt: string;
  status: string;
  salesRep: {
    id: string;
    name: string;
  };
  primaryContact: string;
  address: string;
  recentEstimate: any;
  paymentReceived: number;
  recentInvoice: any;
  balance: number;
  priority: string;
  assignedTo: {
    id: string;
    name: string;
  };
}

export interface IResponseGetCustomerJobs {
  data: IJobEntity[];
  total: number;
  page: number;
  limit: number;
}

export interface ICustomer {
  id: string;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  avatarUrl: string | null;
  address: string;
  addedBy: {
    id: string;
    firstName: string;
    lastName: string;
    avatarUrl: string | null;
  };
  createdDate: string;
}

export interface IResponseGetCustomers {
  responses: Array<ICustomer>;
  pagination: {
    totalItems: number;
    totalPage: number;
    page: number;
    limit: number;
    skip: number;
  };
}

const crmApi = {
  getCRMListView(params: IParamsCRM) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCRMListView>>(`${urlApiCRM.getCRMListView}`, { params });
  },

  createLead(data: IPayloadAddNewLead) {
    return axiosClient.post<IApiBaseResponse<IResponseAddNewLead>>(`${urlApiCRM.createLead}`, data);
  },

  getClientDetails(idClient: string | undefined) {
    return axiosClient.get<IResponseGetClientDetails>(`${urlApiCRM.getClientDetails}/${idClient}`);
  },

  getDocuments(idClient: string | undefined, params: IParamsDocuments) {
    return axiosClient.get<IApiBaseResponse<IResponseGetDocuments>>(`${urlApiCRM.getDocuments}/${idClient}/document`, { params });
  },

  uploadFile(idClient: string | undefined, data: IPayloadUploadFile) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiCRM.uploadFile}/${idClient}/document`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getCustomersList(params: { textSearch?: string; }) {
    return axiosClient.get<IApiBaseResponse<IResponseGetCustomers>>('/api/customers/crm/list', { params });
  },

  createCustomer(data: IPayloadCreateCustomer) {
    return axiosClient.post<IApiBaseResponse<any>>(`${urlApiCRM.createCustomer}`, data);
  },

  updateCustomer(id: string, data: IPayloadCreateCustomer) {
    return axiosClient.put<IApiBaseResponse<any>>(`${urlApiCRM.updateCustomer(id)}`, data);
  },

  deleteCustomer(id: string) {
    return axiosClient.delete<IApiBaseResponse<any>>(`${urlApiCRM.updateCustomer(id)}`);
  },

  getCustomerJobs(customerId: string, params?: {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortType?: 'ASC' | 'DESC';
    jobStage?: string;
    jobType?: string;
    tradeTypes?: number[];
    jobBoard?: string;
    salesRepId?: number;
    assigneeId?: number;
    salesRepSearch?: string;
    assigneeSearch?: string;
  }) {
    return axiosClient.get<IApiBaseResponse<any>>(`/api/customers/crm/${customerId}/jobs`, { params });
  },

  addNote(customerId: string, data: { content: string }) {
    return axiosClient.post<IApiBaseResponse<any>>(`/api/customers/${customerId}/activities`, data);
  },

  getActivities(customerId: string, params?: IParamsActivities) {
    return axiosClient.get<IApiBaseResponse<IResponseGetActivities>>(`/api/customers/${customerId}/activities`, { params });
  },
};

export default crmApi;